import { default as http } from "../rest/http";
import { CoachSessionType } from "../components/pages/UserProfile/sessionDetails";

export interface Topic {
  id: number;
  name: string;
}

export interface TopicCategory {
  id: number;
  name: string;
  topics: Topic[];
}

export interface FileUploadResponse {
  id: number;
  fileName: string;
 
}

export interface SaveNoteRequest {
  financialTopicIds: number[];
  externalLinks: string[];
  sessionOverview: string;
  attachmentIds: number[];
  // Date of Session as a calendar date ("YYYY-MM-DD")
  sessionDate: string;
  sessionType: CoachSessionType;
  isDraft: boolean;
}

export interface CoachNote {
  id: number;
  userId: string;
  coachId?: string;
  financialTopics: Topic[];
  externalLinks: string[];
  attachments: CoachNoteAttachment[];
  sessionOverview: string;
  sessionDate: string | null;
  sessionType: CoachSessionType | null;
  isDraft: boolean;
  createdAt: string;
  updatedAt: string;
  coach: {
    id: string;
    first: string;
    last: string;
  }
}

export interface CoachNoteAttachment {
  id: number;
  fileName: string;
  size?: number;
  name?: string;
}

export const fetchCoachNotes = async (userId: number, page: number = 1, perPage: number = 10) => {
  try {
    const response = await http.get(`/master-data/coach-note/user/${userId}?page=${page}&per_page=${perPage}`);
    return response;
  } catch (error) {
    console.error("Error fetching coach notes:", error);
    throw error;
  }
};

export interface CoachNotesPaginated {
  totalItems: number;
  page: number;
  perPage: number;
  totalPages: number;
  items: CoachNote[];
}

export const fetchAllCoachNotes = async (
  userId: string,
  page: number,
  perPage: number
): Promise<CoachNotesPaginated> => {
  try {
    const response = await http.get(`/master-data/user/${userId}/coach-notes?page=${page}&per_page=${perPage}`);
    return response;
  } catch (error) {
    console.error("Error fetching all coach notes:", error);
    throw error;
  }
};

export const fetchCoachNoteTopics = async (): Promise<TopicCategory[]> => {
  try {
    const response = await http.get("/master-data/lookups/coach-note-topics");
    return response;
  } catch (error) {
    console.error("Error fetching coach note topics:", error);
    throw error;
  }
};

export const uploadAttachment = async (file: File): Promise<FileUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const url = "/master-data/coach-note/attachments";
    
    const response = await http.post(url, formData, 'multipart/form-data');
    return response;
  } catch (error) {
    console.error("Error uploading attachment:", error);
    throw error;
  }
};

export const saveCoachNote = async (noteData: SaveNoteRequest, userId: string) => {
  try {
    const response = await http.post(`/master-data/user/${userId}/coach-notes`, noteData);
    return response;
  } catch (error) {
    console.error("Error saving coach note:", error);
    throw error;
  }
};

export const updateCoachNote = async (noteData: SaveNoteRequest, userId: string, noteId: number) => {
  try {
    const response = await http.put(`/master-data/user/${userId}/coach-notes/${noteId}`, noteData);
    return response;
  } catch (error) {
    console.error("Error updating coach note:", error);
    throw error;
  }
};
